import React from 'react'
import { Col, Row } from 'antd'

import { Input, InputNumber } from 'src/components/Formik'
import { ReferenceCurrencies } from 'src/services/api/currencies'
import { SelectProps } from 'src/components/Formik/Select'
import SelectCurrencyAvailable from 'src/components/Formik/select-currency-available'

interface Props extends Omit<SelectProps, 'name' | 'options'> {
  name?: string
}

export default function SelectCurrencyGroup({ formikProps }: Props) {
  function handleChange(value: ReferenceCurrencies): void {
    formikProps.resetForm({
      active: true,
      code: value?.code || '',
      currency_id: null,
      decimal_digits: value?.decimal_digits || '0',
      name: value?.name || '',
      reference_currency_id: value?.reference_currency_id || null,
      standard: false
    })
  }

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <SelectCurrencyAvailable
            formikProps={formikProps}
            onChange={handleChange}
          />
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col span={8}>
          <Input
            disabled
            formikProps={formikProps}
            label="web.resources.common.code.title"
            name="code"
          />
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col span={16}>
          <Input
            formikProps={formikProps}
            label="web.resources.common.name.title"
            name="name"
            placeholder="web.resources.currencies.name-search"
          />
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col span={16}>
          <InputNumber
            dataTestId="currency-decimal-digits"
            formikProps={formikProps}
            label="web.resources.currencies.decimal-digits"
            max={8}
            min={0}
            name="decimal_digits"
          />
        </Col>
      </Row>
    </>
  )
}
